<template>
  <div class="flex item-center md:items-end">
    <SanityImage
      v-if="!noImage && author.picture"
      class="shrink-0 w-8 h-8 md:w-10 md:h-10 mr-3"
      image-class="rounded-full"
      :image="author.picture"
      :size="{ width: 120, height: 120 }"
      :lazy="false"
      no-copyright
    />
    <MTooltip>
      <template #toggle>
        <div class="flex flex-col">
          <p
            class="dotted-underline text-red-400 font-semibold cursor-pointer"
            data-id="article-author"
          >
            {{ author.name }}
          </p>
          <p class="text-gray-800 text-11 mt-1 md:mt-0">{{ role }}</p>
        </div>
      </template>
      <template #content>
        <div class="flex">
          <SanityImage
            v-if="author.picture"
            class="shrink-0 w-11 h-11 md:w-14 md:h-14 mr-3"
            image-class="rounded-full"
            :image="author.picture"
            :size="{ width: 120, height: 120 }"
            no-copyright
          />
          <p v-if="author.bio" class="text-left text-15 leading-normal text-gray-500">
            {{ author.bio }}
          </p>
        </div>
      </template>
    </MTooltip>
  </div>
</template>

<script lang="ts" setup>
import type { GQLPageMeta } from '@core/composables/use-page-meta/generated/page-meta'

defineProps<{
  author: NonNullable<GQLPageMeta['author'] | GQLPageMeta['reviewer']>
  role: string
  noImage?: boolean
}>()
</script>
